import { match } from 'ts-pattern';
import type { IconName } from '@/components/Icon/iconMap';
import { ASSET_LIFECYCLE_ICON } from '@/constants/assetLifecycleIcon';
import { isDeviceStatus, type DeviceStatus } from '@/constants/device';

/**
 * デバイスステータスに対応するアイコン。
 *
 * 色は持たない。ステータスの色は Badge の variant が単一の定義を持ち、
 * アイコンは `inheritColor` でその文字色を継承する（定義を二重化しない）。
 */
export function getDeviceStatusIcon(status: DeviceStatus): IconName {
  return match<DeviceStatus, IconName>(status).with('IN_STOCK', () => ASSET_LIFECYCLE_ICON.stock).with('IN_USED', () => ASSET_LIFECYCLE_ICON.assignment).with('IN_PLACED', () => ASSET_LIFECYCLE_ICON.placement).with('IN_TROUBLED', () => ASSET_LIFECYCLE_ICON.faulty).with('REFURBISHING', () => ASSET_LIFECYCLE_ICON.refurbishment).with('UNDER_REPAIR', () => ASSET_LIFECYCLE_ICON.repair).with('IN_DISTRIBUTION', () => ASSET_LIFECYCLE_ICON.procurement).with('DECOMMISSIONED', () => ASSET_LIFECYCLE_ICON.decommission).with('DELETED', () => ASSET_LIFECYCLE_ICON.deleted).exhaustive();
}

/**
 * BE の `BadgeValue.code`（DeviceStatus 相当）からアイコン名を解決する。
 * DeviceStatus 以外のコードには `undefined` を返す。
 */
export function deviceStatusBadgeIcon(code: string): IconName | undefined {
  return isDeviceStatus(code) ? getDeviceStatusIcon(code) : undefined;
}